import React, { useState, useEffect } from 'react';

const TimeClock = () => {
  const [totalWorkedTime, setTotalWorkedTime] = useState(0);

  useEffect(() => {
    const fetchTotalWorkedTime = async () => {
      try {
        // TODO: Get chat_id from local storage or context
        const chat_id = "345270079"; // Placeholder
        const response = await fetch(`http://127.0.0.1:5000/total_worked_time?chat_id=${chat_id}`);
        const data = await response.json();
        setTotalWorkedTime(data.total_worked_time);
      } catch (error) {
        console.error('Error fetching total worked time:', error);
      }
    };

    fetchTotalWorkedTime();
    const intervalId = setInterval(fetchTotalWorkedTime, 60000); // Fetch every 60 seconds

    return () => clearInterval(intervalId); // Clean up interval on unmount
  }, []);

  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    return `${hours} h. ${minutes} min.`;
  };

  return (
    <>
      <div>Worked today: {formatTime(totalWorkedTime)}</div>
    </>
  );
};

export default TimeClock;
